// Vendor Libraries
import React, {Component} from 'react';

// Components
import Permissions from '../core/permissions';
import SearchRecordDetails from '../app/search-record-details';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'violationDetail';

class ViolationDetail extends Component {
    getSearchRecordDetailProps() {
        return {
            ...this.props,
            blacklistKeys: ['version'],
            keyOrder: 'violations',
        };
    }

    render() {
        return (
            <Permissions>
                <div className="violations-detail">
                    <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
                </div>
            </Permissions>
        );
    }
}

export default withSearch(ViolationDetail, servicesDataKey);
